(() => {
	const initSliders = () => {
		const slideshowSwiper = new Swiper(document.getElementById('featuredProduct'), {
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			loop: true,
			autoHeight: false,
			allowTouchMove: true,
			slidesPerView: 1.2,
			spaceBetween: 32,
		});
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();